<template>
  <div class='container pt-2 pb-3'>
    <label>{{label}}</label>
    <b-form-file
      placeholder='wybierz plik'
      @change='imageUploaded'
      accept=".jpg, .png, .gif, .jpeg"
    />
    <div v-if='true' class='mt-3 text-center previev-container'>
      <div class='image-size mb-1'>rozmiar obrazka: {{size}}</div>
      <img :src='imageUrl' class='preview' @load='onImageLoad' />
    </div>

  </div>
</template>

<script>
  import { handleFileUpload } from '@/store/utils'
  import { baseURL } from '@/api'

   export default {
    props: ['fieldName', 'label'],
    computed: {
      imageUrl() {
        if (this.base64)
          return this.base64
        if (this.$store.state.fanzones.form[`${this.fieldName}_url`]) {
          //this.baseURL + 
          return this.$store.state.fanzones.form[`${this.fieldName}_url`]
        }
        return null
      },
    },
    data() {
      return {
        imageExists: false,
        actions: { handleFileUpload },
        baseURL: baseURL,
        size: '',
        base64: null,
      }
    },
    methods: {
      imageUploaded(e) {
        this.actions.handleFileUpload(this.fieldName, e.target.files[0])

        const file = e.target.files[0]

        const reader = new FileReader()

        if (file) reader.readAsDataURL(file)

        const uploadData = this.handleUploadData.bind(this)
        reader.addEventListener('load', () => uploadData(reader.result), false)
      },
      handleUploadData(base64) {
        this.base64 = base64
        this.updateImageSize(base64)
      },
      updateImageSize(src) {
        var image = new Image()
        image.src = src
        const setSize = this.setSize.bind(this)
        image.addEventListener('load', () => setSize(image))
      },
      onImageLoad() {
        this.updateImageSize(this.imageUrl)
      },
      setSize(image){
        const { width, height } = image
        this.size = `${width} x ${height}`
      },      
      checkImageExists() {
        return new Promise(
          (resolve) => {
            const image = new Image()
            image.onload = () => resolve(image.width > 0)
            image.onerror = () => resolve(false)
            image.src = this.baseURL + this.$store.state.fanzones.form[`${this.fieldName}_url`]
          }
        )
      }
    },
    async mounted() {
      this.imageExists = await this.checkImageExists()
    }
  }
</script>

<style>
  .preview {
    max-width: 80%;
    max-height: 95%;
  }
  .previev-container {
    height: 200px;
  }
  .container {
    border: 1px solid silver;
    border-radius: 8px;
  }
  .image-size {
    font-size: 12px;
    font-weight: bold;
  }
</style>